import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDrop } from 'react-dnd';
import { cn } from 'twyne-new.ui';

const propTypes = {
  onMove: PropTypes.func,
  tag: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  node: PropTypes.any,
};

function Droppable({ children, tag: Component, onMove, node, type, style, origin, onShowDroppable, ...props }) {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: type,
    drop: draggedItem => {
      onMove({ draggedItem }, { to: node })
    },
    collect: monitor => ({
      isOver: !!monitor.isOver(),
    }),
  }))

  useEffect(() => {
    onShowDroppable && onShowDroppable(isOver);
  }, [isOver, onShowDroppable])

  if (Component) {
    return <Component {...props} ref={drop}
      style={{
        ...style,
      }}
    >
      {children}
    </Component>
  }

  return <tr {...props} ref={drop}
    style={{
      height: '30px',
      width: '100%',
      position: 'absolute',
      zIndex: 20,
      marginTop: '-15px',
      marginBottom: '-15px',
      border: 'none',
    }}
  >
    <td colSpan={20} className={cn(isOver && 'twy-bg-accent', 'p-0 h-1 w-full rounded-sm absolute top-[15px] left-0 right-0 z-30')} />
  </tr>
}

Droppable.propTypes = propTypes;
Droppable.defaultProps = {
  type: "page-item",
};

export default Droppable;
